import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import TextareaBox from '../../../common/interactive/TextareaBox'
import PannelBody from '../../../fragments/PannelBody'
import Button from '../../../common/Button'
import { addTransportationRide, updateTransportationRide } from '../../../../lib/fetchApi'
import { practicesOptions, retrieveTransportaionsData } from '../../../../lib/systemData'
import { notificationActions } from '../../../../store/notifications'
import { isAppointmentRescheduledError } from '../../../../lib/transportation'
import { caseActions } from '../../../../store/case'
import CustomSelect from '../../../common/interactive/CustomSelect'
import { calculateFinalTripCharge } from '../../../../lib/verifications'
import Tag from '../../../fragments/Tag'
import { capitalizeFirstLetter } from '../../../../lib/script'
import { preferedLanguagesOptions } from '../../../../assets/data'

import classes from './RequestRide.module.css'
import RadioFieldCustom from '../../../common/interactive/RadioFieldCustom'

const RequestRide = ({setCanContinue, data, closeModal, edit, lyftResponse, setLyftResponse, onAppointmentRescheduled}) => {
    const dispatch = useDispatch()
    const [notes, setNotes] = useState(edit ? edit.note : "")
    const [preferedLanguage, setPreferedlanguage] = useState(edit ? edit.preferred_lang : "en")
    const [rideType, setRideType] = useState(edit ? edit.lyft_type : null)
    const [clinicName, setClinicName] = useState(null)

    const [loading, setLoading] = useState(false)
    const [refreshLoading, setRefreshLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    let transportationSystemData = retrieveTransportaionsData()

    const lyftRideTypeHandler = (value) => {
        setRideType(value.value)
    }
    const setTextAreaHandler = (value) => {
        setNotes(value.data.value)
    }

    const preferedlanguageHandler = (value) => {
        setPreferedlanguage(value.data.value)
    }

    const driverAvailabilityPrediction =
        lyftResponse?.driver_availability?.driver_availability_predictions?.[0]

    const normalizeCostEstimates = (estimates) => (
        Array.isArray(estimates)
            ? estimates
            : Object.values(estimates ?? {})
    )

    const costEstimates = normalizeCostEstimates(lyftResponse?.estimates?.cost_estimates)

    const selectedLyft = costEstimates.find(item => item.price_quote_id == rideType)

    const estimatedDistanceMiles =
        selectedLyft?.estimated_distance_miles
        ?? costEstimates.find(item => item.estimated_distance_miles != null)?.estimated_distance_miles

    const refreshLyftDataHandler = async () => {
        setRefreshLoading(true)
        try {
            const previousSelectedEstimate = costEstimates.find(item => item.price_quote_id == rideType)
            const previousRideTypeKey = previousSelectedEstimate?.ride_type

            const { origin_address, destination_address, ...apiBody } = data
            const liftData = await addTransportationRide(userToken, activeCase.case.id, {
                ...apiBody,
                step: 1,
                force: 1,
                force_distance: 1,
            }, dispatch)

            if (liftData && liftData.errorMessage) {
                dispatch(notificationActions.setError(liftData))
                if (isAppointmentRescheduledError(liftData)) {
                    onAppointmentRescheduled?.()
                }
            } else if (liftData && liftData.estimates && liftData.estimates.cost_estimates && liftData.estimates.cost_estimates.some(item => item.upfront_cost_cents)) {
                const refreshedEstimates = normalizeCostEstimates(liftData.estimates.cost_estimates)
                setLyftResponse(liftData)

                if (previousRideTypeKey) {
                    const match = refreshedEstimates.find(
                        item => item.ride_type === previousRideTypeKey && !item.error_message
                    )
                    setRideType(match ? match.price_quote_id : null)
                }
            } else {
                dispatch(notificationActions.setError({ errorMessage: 'No Lyft rides are currently available for this route.' }))
            }
        } finally {
            setRefreshLoading(false)
        }
    }

    const requestRideHandler = async () => {
        setLoading(true)
        try {
            if (rideType) {
                let reqBody = {
                    ...data,
                    reciept: null,
                    note: notes,
                    preferred_lang: preferedLanguage,
                    ride_type: "lyft",
                    step: 2,
                    total_milage: selectedLyft?.estimated_distance_miles ?? estimatedDistanceMiles,
                    lyft_charge: selectedLyft?.estimated_cost_cents_max/100
                }
                delete reqBody.origin_address
                delete reqBody.destination_address

                if (selectedLyft) {
                    reqBody.cost_token = selectedLyft.cost_token
                    const driverAvailabilityToken = driverAvailabilityPrediction?.driver_availability_token
                    if (driverAvailabilityToken) {
                        reqBody.driver_availability_token = driverAvailabilityToken
                    }
                    const origin = driverAvailabilityPrediction?.origin
                    if (origin?.lat != null && origin?.lng != null) {
                        reqBody.origin_lat = origin.lat
                        reqBody.origin_lng = origin.lng
                    }
                }
                
                if (!edit) {
                    const ride = await addTransportationRide(userToken, activeCase.case.id,  reqBody, dispatch)
               
                    if (ride && ride.errorMessage) {
                        dispatch(notificationActions.setError(ride))
                        if (isAppointmentRescheduledError(ride)) {
                            onAppointmentRescheduled?.()
                        }
                    } else {
                        dispatch(notificationActions.setError({errorMessage: 'success', type: 'success'}))
                        
                        let dispatchBody = {
                            folder: 'case_transportation',
                            label: 'rides',
                            item: ride
                        }
            
                        dispatch(caseActions.pushItemInObjArray(dispatchBody))
                        closeModal()
                    }
                } else {
                    const ride = await updateTransportationRide(userToken, activeCase.case.id, edit.id, reqBody, dispatch)

                    if (ride && ride.errorMessage) {
                        dispatch(notificationActions.setError(ride))
                        if (isAppointmentRescheduledError(ride)) {
                            onAppointmentRescheduled?.()
                        }
                    } else {
                        dispatch(notificationActions.setError({errorMessage: 'success', type: 'success'}))
                        
                        let dispatchBody = {
                            folder: 'case_transportation',
                            label: 'rides',
                            item: ride
                        }
            
                        dispatch(caseActions.changetemInObjArray(dispatchBody))
                        closeModal()
                    }
                }
            } else {
                dispatch(notificationActions.setError({errorMessage: 'Please select a ryde type!',}))
            }
        } finally {
            setLoading(false)
        }
    }



    useEffect(() => {
        let practices = practicesOptions()
        if (practices)  {
            practices.forEach(item => {                
                if (item.data.locations) {
                    item.data.locations.forEach(element => {
                        if (element.id == data.location_id) {
                            setClinicName(element.code)
                            {/* display_name */}
                        }
                    })
                    
                }
            })
        }
    }, [data]) 

    return <div className={classes.overflow_container}>
        <div className={classes.go_back_container}>
            <button type="button" onClick={() => setCanContinue(false)} disabled={refreshLoading || loading}><i className='ti ti-chevron-left'></i>Go back</button>
        </div>
        

        <div className={classes.from_to_container}>
            <div className={classes.from_to_container_item}>
                <div className={classes.label}>From</div>

                
                <div className={classes.place}>
                    {data?.pickup_at == 'home' ? data.address : clinicName}
                </div>
            </div>
            <div className={classes.separator}>
                <i className='ti ti-arrow-right'></i>
            </div>
            <div className={classes.from_to_container_item}>
                <div className={classes.label}>To</div>
                <div className={classes.place}>
                    {data?.pickup_at == 'home' ? clinicName : data.address}
                </div>
                
            </div>
        </div>

        <div className={classes.details_container}>
            <div className={classes.row}>
                <div>Distance:</div>
                <div className={classes.value}>
                    {estimatedDistanceMiles != null ? `${estimatedDistanceMiles} mi` : '—'}
                </div>
            </div>
            {/* <div className={classes.row}>
                <div>Cost per mile:</div>
                <div className={classes.value}>${transportationSystemData?.price_per_mile}</div>
            </div> */}
            <div className={classes.row}>
                <div>Patient trip charge:</div>
                {/* <div className={classes.value}>${(calculateFinalTripCharge(lyftResponse?.estimates.cost_estimates?.find(item => item.estimated_distance_miles)?.estimated_distance_miles, transportationSystemData?.lyft_multiplier, lyftResponse.estimates.cost_estimates.find(item => item.price_quote_id ==  rideType )))}</div> */}
                <div className={classes.value}>${(calculateFinalTripCharge(transportationSystemData?.lyft_multiplier, selectedLyft))}</div>
            </div>
        </div>

        <PannelBody>
            <div className={`${classes.request_item} ${classes.request_item_flex}`}>
                <h3>Select Lyft ride type</h3>
                <div className={classes.availability_actions}>
                    <button
                        type="button"
                        className={classes.refresh_button}
                        title="Refresh driver availability"
                        onClick={refreshLyftDataHandler}
                        disabled={refreshLoading || loading}
                    >
                        <i className={`ti ti-refresh ${refreshLoading ? classes.refresh_spin : ''}`} />
                    </button>
                    <Tag color={capitalizeFirstLetter(driverAvailabilityPrediction?.driver_availability_level)}>Driver Availability</Tag>
                </div>
            </div>
            <div className={classes.request_item}>
                <RadioFieldCustom fields={costEstimates} identifier={{type: 'lyft_ride'}} action={lyftRideTypeHandler} defaultChecked={rideType}/>
            </div>

            <div className={classes.request_item}>
                <h3>Request Notes</h3>
            </div>

            <div className={classes.request_item}>
                <TextareaBox label={'Notes'} currentValue={notes} action={setTextAreaHandler}/>
            </div>



            <div className={classes.request_item}>
                <div className='relative'>
                    <CustomSelect label={'Prefered Language'} optionsData={preferedLanguagesOptions} preSelectedValue={preferedLanguage} action={preferedlanguageHandler} reverseDrawer={true}/>
                </div>
            </div>


            <div className={classes.form_footer}>
                <Button type='submit' isLoading={loading} isDisabled={refreshLoading} width={'full'} click={requestRideHandler}>
                    Request Ride 
                    <i className="ti ti-chevron-right"></i>
                </Button>
            </div>
        </PannelBody>

        
        
    </div>
}

export default RequestRide